<sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=windowHash>
</sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1" *ngIf="isLoaded ()">
  <div class="container-fluid">
    <ng-container *ngTemplateOutlet="tenderInfo"></ng-container>
    <ng-container *ngIf="tenderingEnvelopes && tenderingEnvelopes.length > 0">
      <div class="row">
        <div class="col-12">
          <h3 class="mt-3">{{'TenderInfo.documents.title' | translate}}</h3>
        </div>
        <div class="col-12">
          <p-accordion (onOpen)="onTabOpen($event)">
            <p-accordionTab *ngFor="let envelope of tenderingEnvelopes; index as i" header="{{envelope.description}}"
              [selected]="selectedTab === i">
              <ng-container *ngIf="envelope['_files']">
                <ng-container [ngTemplateOutlet]="tenderDocsTpl" [ngTemplateOutletContext]="{
              envelopeDocs: envelope['_files'],
              envelope: envelope,
              enabledEnvelope: isEnvelopeEditable(envelope)
            }"></ng-container>
              </ng-container>
            </p-accordionTab>
          </p-accordion>
        </div>
      </div>
    </ng-container>
  </div>
</p-scrollPanel>
<ng-template #tenderInfo>
  <div class="row">
    <div class="col-12">
      <h3>{{ 'TenderInfo.tenderData' | translate }}</h3>
    </div>
    <div class="col-12">
      <div class="row m-t-md">
        <div class="col-12 col-md-6">
          <dl class="row">
            <dt class="col-12 col-md-6">{{ 'TenderInfo.tenderType' | translate }}:</dt>
            <dd class="col-12 col-md-6">
              <span>
                <i class="fa fa-envelope" aria-hidden="true"></i> {{ ((tender.isElectronicTender) ?
                'TenderInfo.electronic' :'TenderInfo.paper') | translate }} </span>
            </dd>
            <dt class="col-12 col-md-6">{{ 'General.state' | translate }}:</dt>
            <dd class="col-12 col-md-6">
              <span
                *ngIf="tender.document?.currentState?.type?.description">{{tender.document?.currentState.type.description}}</span>
              <span *ngIf="!tender.document?.currentState?.type?.description">{{ 'TenderStateDTO.v2.' +
                tender.document.currentState.identifier | translate }}</span>
            </dd>
            <dt class="col-12 col-md-6">{{ 'TenderInfo.registerNumber' | translate }}:</dt>
            <dd class="col-12 col-md-6">
              <span>{{ tender.tenderSubmission.receptionRegistrationNumber }}</span>
            </dd>
            <dt class="col-12 col-md-6">{{ 'TenderInfo.registerDate' | translate }}:</dt>
            <dd class="col-12 col-md-6">
              <span *ngIf="tender?.tenderSubmission?.submissionDate">{{ tender.tenderSubmission.submissionDate | date:
                'dd-MM-yyyy HH:mm:ss' }}</span>
            </dd>
          </dl>
        </div>
        <div class="col-12 col-md-6"
          *ngIf="!hasLots && (stateChangeEnabled || enableRejectOnRegister) && tender.tenderLots && tender.tenderLots.length > 0 && tender.tenderLots[0].tenderEvaluation">
          <div class="row" *ngIf="this.task?.work?.context?.configurations?.modeEnvelopeOpeningEnabled?.value">
            <dt class="col-12 col-md-6">{{'TenderEvaluation.lowTender' | translate}}</dt>
            <dd class="col-12 col-md-3">
              <p-dropdown [options]="yesNoModel" (onChange)="lowTender($event.value, tender)"
                [ngModel]="tender.tenderLots[0].tenderEvaluation.isConsideredAsAbnormallyLowTender"></p-dropdown>
            </dd>
          </div>
          <div class="m-t-md" *ngIf="tender.document?.currentState?.identifier === TenderStateDTOV2.INITIAL ||
                 (enableRejectOnRegister && tender.document?.currentState?.identifier === TenderStateDTOV2.ACCEPTED)">
            <button class="text-center btn btn-sm btn-outline-secondary" aria-expanded="false"
              (click)="rejectTenderState(tender)" appNoDblClick>
              <i [ngClass]="'fas fa-times'"></i> {{ 'TenderEvaluation.reject'| translate }} </button>
            <button class="ml-1 text-center btn btn-sm btn-primary" aria-expanded="false"
              (click)="acceptTenderState(tender)" appNoDblClick *ngIf="stateChangeEnabled">
              <i [ngClass]="'fa fa-check'"></i> {{ 'TenderEvaluation.accept' | translate }} </button>
          </div>
          <div class="m-t-md"
            *ngIf="stateChangeEnabled && (tender.document?.currentState?.identifier === TenderStateDTOV2.ACCEPTED || tender.document?.currentState?.identifier === TenderStateDTOV2.REJECTED)">
            <button class="text-center btn btn-sm btn-primary" aria-expanded="false" (click)="changeTenderState(tender)"
              appNoDblClick>
              <i
                [ngClass]="(tender.document?.currentState?.identifier === TenderStateDTOV2.ACCEPTED)?'fas fa-times':'fa fa-check'"></i>
              {{ ((tender.document?.currentState?.identifier=== TenderStateDTOV2.ACCEPTED)? 'TenderEvaluation.reject' :
              'TenderEvaluation.accept') | translate}} </button>
          </div>
        </div>
      </div>
      <ng-container *ngIf="hasLots && tender.tenderLots && tender.tenderLots.length > 0">
        <h3>{{'TenderEvaluation.lots.title' | translate}}</h3>
        <div class="lotes">
          <p-table [value]="tender.tenderLots" [responsive]="true" dataKey="identifier" [editMode]="'row'">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ lotsColHeaders[0] | translate }}</th>
                <th class="text-center">{{ lotsColHeaders[1] | translate }}</th>
                <th class="text-center">{{ lotsColHeaders[2] | translate }}</th>
                <th class="text-center"
                  *ngIf="this.task?.work?.context?.configurations?.modeEnvelopeOpeningEnabled?.value">{{
                  lotsColHeaders[3] | translate }}</th>
                <th [style.width]="'10%'" *ngIf="stateChangeEnabled || enableRejectOnRegister"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-lot let-editing="editing" let-ri="rowIndex">
              <tr [pEditableRow]="lot" [pEditableRowDisabled]="stateChangeEnabled || enableRejectOnRegister">
                <td class="text-truncate">
                  <span class="p-column-title">{{ lotsColHeaders[0] | translate }}</span> {{ getLotDescription(lot)}}
                </td>
                <td class="text-center">
                  <span class="p-column-title">{{ lotsColHeaders[1] | translate }}</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-dropdown [options]="(lot.tenderEvaluation.admissionStatus.statusCode === TenderAdmissionStatusCodeDTO.INITIAL) ?
                        tenderLotStatesWithInitial : tenderLotStates"
                        [(ngModel)]="lot.tenderEvaluation.admissionStatus.statusCode">
                      </p-dropdown>
                    </ng-template>
                    <ng-template pTemplate="output"> {{('TenderAdmissionStatusCodeDTO.' +
                      lot.tenderEvaluation.admissionStatus.statusCode) | translate}} </ng-template>
                  </p-cellEditor>
                </td>
                <td class="text-center">
                  <span class="p-column-title">{{ lotsColHeaders[2] | translate }}</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <textarea class="textarea-autoheight align-bottom" [autoResize]="true" [rows]="1" [cols]="20"
                        [(ngModel)]="lot.tenderEvaluation.admissionStatus.statusReason" pInputTextarea></textarea>
                    </ng-template>
                    <ng-template pTemplate="output"> {{lot.tenderEvaluation.admissionStatus.statusReason}}
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td *ngIf="this.task?.work?.context?.configurations?.modeEnvelopeOpeningEnabled?.value">
                  <span class="p-column-title">{{ lotsColHeaders[3] | translate }}</span>
                  <p-cellEditor>
                    <ng-template pTemplate="input">
                      <p-dropdown [options]="yesNoModel" [disabled]="(enableRejectOnRegister)? 'disabled':undefined"
                        [(ngModel)]="lot.tenderEvaluation.isConsideredAsAbnormallyLowTender">
                      </p-dropdown>
                    </ng-template>
                    <ng-template pTemplate="output">
                      <div class="text-center">
                        {{
                        (
                        (!lot.tenderEvaluation?.isConsideredAsAbnormallyLowTender ||
                        lot.tenderEvaluation?.isConsideredAsAbnormallyLowTender === TriStateDTO.UNDEFINED) ?
                        'General.undefined'
                        :
                        (
                        (lot.tenderEvaluation?.isConsideredAsAbnormallyLowTender === TriStateDTO.YES) ?
                        'General.yes' : 'General.no'
                        )
                        )
                        | translate
                        }}
                      </div>
                    </ng-template>
                  </p-cellEditor>
                </td>
                <td class="float-right d-flex justify-content-end text-right"
                  *ngIf="stateChangeEnabled || enableRejectOnRegister">
                  <div class="btn-group">
                    <button *ngIf="!editing" pButton type="button" pInitEditableRow icon="fa fa-pencil"
                      class="btn btn-sm btn-secondary t-action-button" (click)="onLotEditInit(lot)" appNoDblClick
                      title="{{ 'General.edit' | translate }}"></button>
                    <button *ngIf="editing" pButton type="button" pCancelEditableRow icon="fas fa-times"
                      class="btn btn-sm btn-secondary t-action-button" (click)="onLotEditCancel(lot)" appNoDblClick
                      title="{{ 'General.cancel' | translate }}"></button>
                    <button *ngIf="editing" pButton type="button" pSaveEditableRow icon="fa fa-save"
                      class="btn btn-sm btn-secondary t-action-button" (click)="onLotEditSave(lot, tender)"
                      title="{{ 'General.save' | translate }}" appNoDblClick></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>
<ng-template #tenderDocsTpl let-envelope="envelope" let-envelopeDocs="envelopeDocs"
  let-enabledEnvelope="enabledEnvelope">
  <div class="row">
    <div class="col-12">
      <p-table [value]="envelopeDocs" [rows]="20" [paginator]="false" [pageLinks]="4"
        [rowsPerPageOptions]="[15, 30, 100]" class="footer-over-pagination mb-3">
        <ng-template pTemplate="header">
          <tr>
            <th class="col-icon"></th>
            <th class="TEXTTH-w200 th-wrap">{{'TenderEvaluation.documents.name'|translate}}</th>
            <th class="text-center col-icon">{{'Envelope.edit.required' |translate}}</th>
            <th class="text-center col-icon">{{'TenderEvaluation.documents.included' |translate}}</th>
            <th class="text-center col-icon">{{'TenderEvaluation.documents.rectifiable' |translate}}</th>
            <th class="action-button text-right"> {{ 'AwardInfo.table.actions' | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-doc>
          <tr>
            <td class="col-icon">
              <span>
                <i class="fa fa-2x m-r-md"
                  [ngClass]="documentService.getIconType((doc.documentFile) ? doc.documentFile.name : undefined)"
                  aria-hidden="true"></i>
              </span>
            </td>
            <td class="TEXTTH-w200 th-wrap">
              <tenderDocumentDetail [documentV2]="doc"></tenderDocumentDetail>
            </td>
            <td class="text-center col-icon">
              <span><i class="far fa-lg"
                  [ngClass]="(doc.relatedEnvelopeDocumentDefinition?.required) ? 'fa-check-square':'fa-square'"
                  [attr.aria-label]="translateService.instant((doc.relatedEnvelopeDocumentDefinition?.required)?'General.yes':'General.no')"></i></span>
            </td>
            <td class="text-center col-icon">
              <span><i class="far fa-lg"
                  [ngClass]="(doc.documentCheckResult?.documentIsIncluded) ? 'fa-check-square':'fa-square'"
                  [attr.aria-label]="translateService.instant((doc.documentCheckResult?.documentIsIncluded)?'General.yes':'General.no')"></i></span>
            </td>
            <td class="text-center col-icon">
              <span><i class="far fa-lg"
                  [ngClass]="(doc.documentCheckResult?.documentIsSubsanable) ? 'fa-check-square':'fa-square'"
                  [attr.aria-label]="translateService.instant((doc.documentCheckResult?.documentIsSubsanable)?'General.yes':'General.no')"></i></span>
            </td>
            <td class="action-button text-right">
              <div class="float-right btn-group d-flex justify-content-end text-right">
                <button appDebounceClick class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                  [disabled]="!enabledEnvelope" (debounceClick)="editDocument(doc)"
                  title="{{ 'General.modify' | translate }}">
                  <i class="fas fa-pencil-alt" aria-hidden="true"></i>
                </button>
                <button appDebounceClick class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                  (debounceClick)="viewDocument(doc)"
                  [disabled]="!doc.documentFile || !documentService.isPdf(doc.documentFile)"
                  title="{{ 'General.visualize' | translate }}{{ (doc?.documentFile?.name) ? doc.documentFile.name.toUpperCase().substring(doc.documentFile.name.lastIndexOf('.')+1) : '' }}">
                  <i class="fas fa-eye" aria-hidden="true"></i>
                </button>
                <button appDebounceClick class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                  (debounceClick)="downloadDocument(doc)" [disabled]="!doc.documentFile" title="{{ 'General.download' |
                  translate }}">
                  <i class="fas fa-download" aria-hidden="true"></i>
                </button>
                <button appDebounceClick class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
                  (debounceClick)="deleteDocument(doc, envelope)"
                  [disabled]="doc.relatedEnvelopeDocumentDefinition?.identifier" title="{{ 'General.delete' |
                  translate }}">
                  <i class="fas fa-times" aria-hidden="true"></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="float-right btn-group" role="group">
        <button type="button" class="btn btn-outline-secondary btn-sm add-button ml-2"
          *ngIf="editMode && enabledEnvelope" [disabled]="!editMode ? 'disabled' : null" (click)="addDocument(envelope)"
          title="{{ 'General.add' | translate}}">
          <i class="p-button-icon-left ui-clickable fas fa-plus" aria-hidden="true"></i><span
            class="p-button-text ui-clickable">{{ 'General.add' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>